module.exports = __webpack_public_path__ + "409a44b94da3f4443c615f39915890a8.png";